var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M4.167 10h11.666m0 0L12.5 13.333M15.833 10 12.5 6.667","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }